import { render, staticRenderFns } from "./ItemElementMeta.vue?vue&type=template&id=5e93e153&scoped=true"
import script from "./ItemElementMeta.vue?vue&type=script&lang=ts"
export * from "./ItemElementMeta.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementMeta.vue?vue&type=style&index=0&id=5e93e153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e93e153",
  null
  
)

export default component.exports